import { render, staticRenderFns } from "./CreatePass.vue?vue&type=template&id=a5dd9088&scoped=true&"
import script from "./CreatePass.vue?vue&type=script&lang=js&"
export * from "./CreatePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dd9088",
  null
  
)

export default component.exports